import React from 'react';
import { useTheme } from '@mui/material/styles';

const BrandLogo = ({ variant = 'default', width = 200 }) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  
  return (
    <img 
      src={isDark ? '/logo-light.svg' : '/logo-dark.svg'} 
      alt="Aquamire Capital" 
      style={{ width }} 
    />
  );
};

export default BrandLogo;
